
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/country/[slug]",
      function () {
        return require("private-next-pages/country/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/country/[slug]"])
      });
    }
  